import cn from 'classnames'

import { Pencil } from 'components'

import './styles.scss'

interface EditBlockProps {
  children: React.ReactNode
  onClick?: () => void
  onEdit?: () => void
  className?: string
}

export const EditBlock = ({ children, className, onClick, onEdit }: EditBlockProps) => {
  const handleEdit = (e: React.MouseEvent) => {
    e.stopPropagation()
    onEdit?.()
  }

  return (
    <div className={cn('edit-block-container', className)} onClick={onClick}>
      {children}
      <Pencil className="edit-icon" onClick={handleEdit} />
    </div>
  )
}
